'use client';
import React, { memo } from 'react';
import Image from 'next/image';

import { Divider, IButton, ITypo } from '@/app/_components/common';
import { Icons, Logo } from '@/app/assets/Icons';
import { HEADER_NAV_ITEMS, ROUTERS } from '@/constants/Router.constant';
import { map } from '@/utils';
import { cn, Link } from '@nextui-org/react';

import NavMobileItem from './NavMobileItem';

interface IProps {
	isScrolled: boolean;
	isOpen: boolean;
	onOpenChange: (open?: boolean) => void;
	pathname: string;
}

const NavMobile: React.FC<IProps> = ({
	isScrolled,
	isOpen,
	onOpenChange,
	pathname,
}) => {
	return (
		<>
			<aside
				className={cn(
					'col fixed inset-0 right-8 z-[9999] bg-white transition-transform lg:hidden',
					{
						'translate-x-0': isOpen,
						'translate-x-[-120%]': !isOpen,
					}
				)}
			>
				<IButton
					onClick={() => onOpenChange(false)}
					variant="transparent"
					isIconOnly
					className="text-gray absolute right-4 top-4 z-50 h-10 min-h-10 w-10 !p-0 lg:hidden"
				>
					<div className="relative h-4 w-4 shrink-0">
						<Image
							src={Icons.header.navClose}
							fill
							alt="DLA Da Nang"
						/>
					</div>
				</IButton>

				<Link href={ROUTERS.HOME} className="center my-8 w-full">
					{/* <div className="relative h-[58px] min-w-[32px]">
						<Image src={Icons.common.logo} fill alt="DLA Da Nang" />
					</div> */}
					<Logo className={cn('text-bittersweet')} />
				</Link>

				<Divider className="mb-8" />

				<ul className="col divide-silver divide-y px-4">
					{map(HEADER_NAV_ITEMS, (item, idx) => {
						const isActive = item.href === pathname;
						return (
							<NavMobileItem
								{...item}
								key={idx}
								isScrolled={false}
								isActive={isActive}
								onOpenChange={onOpenChange}
							/>
						);
					})}
				</ul>

				{/* footer */}
				<div className="col flex-1 justify-end">
					<Divider />

					<div className="col bg-bittersweet p-4 text-left text-white">
						<ITypo size={12} as="p">
							CÔNG TY CỔ PHẦN GIÁO DỤC QUỐC TẾ DLA | Giấy ĐKKD số
							0401765207 do Sở Kế hoạch và Đầu tư TP. Đà Nẵng cấp
							ngày 18/05/2016
						</ITypo>
					</div>
				</div>
			</aside>

			{/* backdrop */}
			<div
				className={cn(
					'fixed inset-0 z-[8888] bg-black bg-opacity-20 lg:hidden',
					{
						'translate-x-0': isOpen,
						'translate-x-[-120%]': !isOpen,
					}
				)}
				onClick={() => onOpenChange(false)}
			/>
		</>
	);
};

export default memo(NavMobile);
